// extracted by mini-css-extract-plugin
module.exports = {"title":"TileAccountFavorites_title_3RTU6","tile":"TileAccountFavorites_tile_3TSY6","imageContainer":"TileAccountFavorites_imageContainer_1xAW-"};